import React from 'react';
import { CalendarIcon } from 'components/common/icons';
import { FilterDrawer } from 'components/common';
import { Col, DatePicker, Form, FormInstance, Row, SupplierSelect } from 'components';
import { useFilters } from './useFilters';

const { RangePicker } = DatePicker;

interface IFilters {
  form: FormInstance;
  drawerOpen: boolean;
  closeDrawer: () => void;
  applyFilters: (value: Record<string, any>) => void;
  resetFilters: () => void;
}

export const Filters = React.memo((props: IFilters) => {
  const { form, drawerOpen, closeDrawer, applyFilters, resetFilters } = props;
  const { clearFilters } = useFilters({ form, resetFilters });

  return (
    <FilterDrawer
      title="Filter"
      placement="left"
      width={471}
      styles={{
        body: {
          marginBottom: 80,
        },
      }}
      onClose={closeDrawer}
      open={drawerOpen}
      onApply={() => form.submit()}
      onClear={clearFilters}
      onExpand={closeDrawer}
    >
      <Form layout="vertical" form={form} onFinish={applyFilters}>
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <Form.Item name="supplierId" label={'Supplier'}>
              <SupplierSelect />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="createDate" label={'Created Date'}>
              <RangePicker suffixIcon={<CalendarIcon />} className={'w-100'} popupClassName={'fmg-range-picker'} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="expiryDate" label={'Expiry Date'}>
              <RangePicker suffixIcon={<CalendarIcon />} className={'w-100'} popupClassName={'fmg-range-picker'} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </FilterDrawer>
  );
});
